/**
 * 是否移动端
 */
export const useIsMobile = () => {
  const viewport = useViewport()
  const isMob = computed(() => viewport.isLessThan('tablet') as boolean)
  return isMob
}
